import React, { createContext, useContext, useMemo } from "react";

type FilterMenuContextValue = {
  /** The popup id; threaded to the chip's `aria-controls` and the popup's `id`. */
  id: string;
  /** Shared callback fired by the chip's X and the popup header's Clear button. */
  onClear?: () => void;
};

const Context = createContext<FilterMenuContextValue | undefined>(undefined);

export const FilterMenuContext: React.FC<
  React.PropsWithChildren<FilterMenuContextValue>
> = ({ children, id, onClear }) => {
  const value = useMemo(() => ({ id, onClear }), [id, onClear]);
  return <Context value={value}>{children}</Context>;
};

export const useFilterMenuContext = () => {
  const context = useContext(Context);
  if (!context) {
    throw new Error("FilterMenuContext not found");
  }
  return context;
};
